<template>
  <section class="splash-page splash-page-mobile splash-page--mobile splash-page--mobile-ge" v-show="!isLoading"
    @click="backgroundClick">

    <div class="splash-page-modal-graphic-editor-img" ref="partsCustomize">

      <div :class="[
        'splash-page__ge-zoom',
        'splash-page__header-tools',
        regionIsApac ? 'splash-page__header-tools--apac' : ''
      ]" v-show="verifyModuleVisibility('header') && isUgcApplied">
        <img class="splash-page__arrow splash-page__arrow--tools"
          :src="`${customsAssets}/svg/customizer/icon-hand-zoom.svg`">
        <label class="splash-page__label">{{ getTranslation('scrollToZoom') }}</label>
      </div>

      <div :class="[
        'splash-page__ge-customize',
        'splash-page__header-tools',
        regionIsApac ? 'splash-page__header-tools--apac' : ''
      ]" v-show="verifyModuleVisibility('header')">
        <img class="splash-page__arrow splash-page__arrow--tools"
          :src="`${customsAssets}/svg/customizer/icon-hand-touch.svg`">
        <label class="splash-page__label">{{ getTranslation('tapGraphicCustomize') }}</label>
      </div>


      <div class="splash-page__ge-drag-rep-img" v-show="verifyModuleVisibility('tabs') && isUgcApplied">
        <img class="splash-page-desktop__arrow" :src="`${customsAssets}/svg/customizer/icon-hand-direction.svg`">
        <label class="splash-page__label">{{ getTranslation('dragRepositionImage') }}</label>
      </div>

          <modal-button-nav
      ref="modalButtonNav"
      :cta-primary-button="skipToGetStartedTranslation"
      :show-icon-button="false"
      :show-cta-secondary-button="false"
      :show-cta-primary-button="true"
      :block-cta-primary-button="false"
      @ctaPrimaryAction="onSkip"
      class="button-nav"
    ></modal-button-nav>

    </div>

    <div class="splash-page__ge-done">
      <label class="splash-page_ge-done-button">
        {{ translations.apparel.graphicZoomOut }}
      </label>
      <img class="splash-page-desktop__arrow"
        :src="`${customsAssets}/images/customizer/add-your-own-arrow-step2.png`">
      <label class="splash-page__label">{{ getTranslation('tapDone') }}</label>
    </div>


  </section>
</template>

<script>
import modalButtonNav from '@/components/Globals/ModalButtonNav';

export default {
  name: "GraphicEditorMobile",
  components: {
    modalButtonNav,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    isTouchStarted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      styledElements: {},
      initialTimestamp: null,
    };
  },
  computed: {
    activeComponent() {
      return this.$store.state.standardNavigation.activeComponent;
    },
    translations() {
      return this.$store.state.translations.data;
    },
    customsAssets() {
      return this.$store.state.endPoints.customizer.customsAssets;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    regionIsApac() {
      return this.$store.getters["utils/regionIsApac"];
    },
    skipToGetStartedTranslation() {
      return this.translations.simplifiedSplashPage.mobile['skipToGetStarted'];
    },
    isUgcApplied() {
      return this.$recipe.checkApparelUGC();
    }
  },
  watch: {
    isLoading(newValue) {
      if (!newValue) {
        this.showComponentsHelpers();
      }
    }
  },
  methods: {
    backgroundClick(event) {
      if (event.target.classList.contains("splash-page-modal-graphic-editor-img")) {
        this.closeClick();
      }
    },
    getTranslation(key) {
      return this.translations.simplifiedSplashPage.mobile[key];
    },
    closeClick() {
      if (!this.regionIsApac) {
        document.getElementsByClassName("v--modal-overlay")[0].style.position =
          "fixed";
      }
      this.toggleSplashPageOpenClass('remove');
      this.isLoading = false;
      this.$modal.hide('splashPageModal');
      this.$store.commit('utils/SET_IS_SPLASH_MODAL_OPEN', false);
    },
    setStyleForElements() {
      document
        .getElementsByClassName("v--modal-overlay")[0]
        .style.setProperty("z-index", "1100", "important");
      this.checkAllPartsOverlaps();
    },
    toggleSplashPageOpenClass(method = 'add') {
      const selectors = ["graphics-controller__zoom-in", "graphics-controller__detailed-editor", "graphics-controller__detailed-editor-container"];
      for (let selector of selectors) {
        try {
          if (selector === "swatches-view-header" && !this.verifyModuleVisibility('buy_panel')) {
            document.getElementsByClassName(selector)[0].classList[method]('splash-desktop-modal-open-alt-bottom');
          } else {
            document.getElementsByClassName(selector)[0].classList[method]('splash-desktop-modal-open');
          }
        } catch (err) {
          console.error(`not existing class: ${selector}`)
        }
      }
    },
    onSkip() {
      const timeElapsed = (Date.now() - this.initialTimestamp) / 1000;
      this.$customizerDataLayer.logAnalyticsEvent({
        type: this.$customizerDataLayer.types.customizerSplashPage,
        eventLabel: `Skip to Get Started - ${timeElapsed.toFixed(2)} sec`,
        forceEcomDataLayerFormat: true
      });
      this.closeClick();
    },
    showComponentsHelpers() {
      this.toggleSplashPageOpenClass();
    },
    verifyModuleVisibility(module) {
      const general_splash_page = this.configuration.splash_page
        .models_properties;
      const pdm_model = this.$store.state.utils.pdmModel;
      const model_splash_page =
        general_splash_page[pdm_model] || general_splash_page["default"];
      return model_splash_page[module];
    },
    checkAllPartsOverlaps() {
      const innerHeight = window.innerHeight;
      const partsCustomize = this.$refs.partsCustomize;
      const partsCustomizeRect = partsCustomize.getBoundingClientRect();
      const querySelector = this.$store.getters["utils/isApparelEnabled"] ? '.graphics-controller__detailed-editor.splash-desktop-modal-open' : '.customizer-legacy-navigation.splash-desktop-modal-open';
      const navTop = document.querySelector(querySelector).getBoundingClientRect().top;
      if (navTop < partsCustomizeRect.bottom)
        partsCustomize.style.bottom = `${innerHeight - (navTop - 10)}px`;
    },
  },
  created() {
    window.addEventListener("resize", this.setStyleForElements);
  },
  mounted() {
    this.initialTimestamp = Date.now();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setStyleForElements);
  }
};
</script>